import { IonButton, IonButtons, IonIcon, IonToolbar } from '@ionic/react'
import { arrowBack } from 'ionicons/icons'
import { useEffect } from 'react'
import error from '../../assets/images/error.svg'
import claroLogo from '../../assets/images/claro.png'
import { useAppContext } from '../../context/AppContext'
import { useHistory } from 'react-router'
import Button from '../../components/Button'

const InvalidSession = () => {
  const { setBlockNavigation }: any = useAppContext()
  const history = useHistory()
  const goBack = () => {
    history.push('/logout')
    location.reload()
  }

  useEffect(() => {
    setBlockNavigation(true)
    return () => {
      setBlockNavigation(false)
    }
  }, [])

  const onRetry = () => {
    location.href = '/procedures'
  }

  return (
    <>
      <header>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={goBack}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <img src={claroLogo} alt="back page button" className="max-height-22" />
        </IonToolbar>
      </header>
      <main className="landing">
        <div className="landing-container">
          <img src={error} style={{ height: '143px' }} />
          <h3 className="invalid-title">Ocurrió un error inesperado al validar el inicio de sesión</h3>
          <h5 className="invalid-subtitle">Si el problema persiste reporta el incidente a hdc@claro.com.ar</h5>
          <Button
            id="retry-session-validation"
            label="Reintentar"
            landing
            className="submit-button button-size"
            handleSubmit={onRetry}
          />
        </div>
      </main>
    </>
  )
}

export default InvalidSession
